import React from 'react';
import classNames from 'classnames';
import './styles.css';

class ButtonSwitch extends React.Component<any> {
  state = {
    selected: ''
  };

  componentDidMount() {
    if (this.props.initialValue) {
      this.setState({selected: this.props.initialValue});
    }
  }

  // Calls this.props.onChange
  changeTo = option => {
    if (!this.props.disabled) {
      this.setState(
        {selected: option.value},
        this.props.onChange && this.props.onChange(option)
      );
    }
  };

  render() {
    const {options, className, disabled = false} = this.props;
    return (
      <div
        className={classNames(
          className,
          'ButtonSwitch',
          'colab-small-border-radius',
          {'ButtonSwitch--disabled': disabled}
        )}>
        {options.map((option, index) => {
          const classes = classNames(
            'ButtonSwitch__option',
            'colab-bold',
            'colab-centered',
            {'colab-clickable': !disabled},
            {
              'ButtonSwitch__option--active':
                option.value === this.state.selected
            }
          );

          return (
            <div
              key={option.uuid || option.id || index}
              className={classes}
              onClick={() => !disabled && this.changeTo(option)}>
              {option.label}
            </div>
          );
        })}
      </div>
    );
  }
}

export default ButtonSwitch;
